module.exports = __webpack_public_path__ + "18d5276192fde9560f6f73723879a100.MP3";